export default "__VITE_ASSET__CftY_yS1__"